import { useEffect } from "react";
import { Instagram, ArrowUpRight } from "lucide-react";

const posts = [
  { url: "https://www.instagram.com/reel/DU8tolJjDtL/", kind: "reel" },
  { url: "https://www.instagram.com/reel/C9X-p_VoBII/", kind: "reel" },
  { url: "https://www.instagram.com/reel/Cu-GP25o6Uf/", kind: "reel" },
  { url: "https://www.instagram.com/p/CXuWrv6oE4H/", kind: "post" },
];

export const InstagramFeed = () => {
  useEffect(() => {
    // Load Instagram embed script once and (re)process embeds on mount
    const SCRIPT_ID = "instagram-embed-script";
    const process = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.async = true;
      script.src = "https://www.instagram.com/embed.js";
      script.onload = process;
      document.body.appendChild(script);
    } else {
      process();
    }
  }, []);

  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="relative py-24 md:py-32 bg-black border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Instagram className="w-4 h-4 text-sky-400" />
              <span className="font-mono text-[11px] tracking-[0.3em] text-sky-400 uppercase">
                Latest from @ted.cafe.chk
              </span>
            </div>
            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95]">
              Ζωντανα <span className="text-sky-400">απο το Instagram.</span>
            </h2>
          </div>
          <a
            href="https://www.instagram.com/ted.cafe.chk/"
            target="_blank"
            rel="noreferrer noopener"
            data-testid="ig-follow-cta"
            className="group inline-flex items-center gap-2 border border-zinc-700 text-white font-bold uppercase tracking-widest px-6 py-3 text-xs hover:border-sky-400 hover:text-sky-400 transition-colors self-start md:self-auto"
          >
            <Instagram className="w-4 h-4" />
            Follow us
            <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {posts.map((p, i) => (
            <div
              key={p.url}
              data-testid={`ig-embed-${i}`}
              className="ig-embed-wrap relative border border-zinc-800 bg-zinc-950 overflow-hidden hover:border-sky-400/50 transition-colors"
            >
              <blockquote
                className="instagram-media"
                data-instgrm-permalink={`${p.url}?utm_source=ig_embed&utm_campaign=loading`}
                data-instgrm-version="14"
                style={{
                  background: "#0A0A0A",
                  border: 0,
                  margin: 0,
                  maxWidth: "100%",
                  minWidth: "260px",
                  padding: 0,
                  width: "100%",
                }}
              >
                <a
                  href={p.url}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="block p-6 text-zinc-400 hover:text-sky-400 transition-colors text-sm"
                >
                  View {p.kind} on Instagram ↗
                </a>
              </blockquote>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-xs font-mono text-zinc-600 tracking-widest uppercase">
          Posts loaded directly from Instagram · Powered by Meta embeds
        </p>
      </div>
    </section>
  );
};
